<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Seleccionar patio</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <div class="form-field select">
                    <div class="select-field">
                        <select name="seleccion_patio" v-model="form.yard_id" id="seleccione_patio">
                            <option value="" disabled>Seleccione...</option>
                            <option :value="yard.code" v-for="yard in yards" :key="yard.code">
                                {{ yard.name }}
                            </option>
                        </select>
                        <label for="seleccione_patio">Patio</label>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-buttons">
            <button type="button" @click="confirmar" class="btn-success"><i class="fa fa-check"></i><span>Confirmar</span></button>
            <!-- <button type="button" @click="cerrar" class="btn-danger btn--text"><i class="fa fa-times"></i><span>Cerrar</span></button> -->
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            form: {
                yard_id: ''
            },
            yards: []
        };
    },
    methods: {
        cargarPatios: function () {
            axios.get(url + '/cargar-patios').then(({data}) => {
                this.yards = data.patios;
                if (this.yards.length > 0) {
                    this.form.yard_id = this.yards[0].code;
                }
            }).catch(() => {
                swal('Hubo un error, intente nuevamente.', 'Error', 'error');
            });
        },
        confirmar: function () {
            if (this.form.yard_id == '') {
                swal('Debe seleccionar un patio.', 'Aviso', 'warning');
            }
            else {
                axios.post(url + '/seleccionar-patio', this.form).then(() => {
                    window.location.reload(true);
                }).catch(() => {
                    swal('Hubo un error, intente nuevamente.', 'Error', 'error');
                })
            }
        },
        cerrar: function () {
            this.$emit('cerrar');
        }
    },
    mounted: function () {
        this.cargarPatios();
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/ListadoPatiosDefecto.vue